export default __webpack_public_path__ + "locales/tr/BackupCodesDialog.json?hash=f9dc4309829ce67321d150a08bdeec70";